export default "__VITE_ASSET__53e774f2__"